// latest: zhangmyh 2017-3-20 4:38 PM
import './global'
// fn 通常是ajax请求
const btnClickMask = function (fn) {
  var e = arguments[arguments.length - 1]
  var el = e.target.parentElement
  el.setAttribute('disabled', 'disabled')
  fn().then(() => {
    el.removeAttribute('disabled')
  }).catch(() => {
    el.removeAttribute('disabled')
  })
}

const getBackUrl = function () {
  return window.document.referrer
}

export {
  btnClickMask,
  getBackUrl
}



// WEBPACK FOOTER //
// ./src/common/utils.js